export const enum PRODUCT_TYPE_ENUMERATION {
  RAPI_PLAZO = 'RP',
  RAPI_FLEX = 'RF',
}

export const enum COOKIE_ENUMERATION {
  ORIGIN = '__origin',
  CRFRAP = '__crfrap',
  STATUS = '__status',
  TERM = 'term',
  AMOUNT = 'amount',
  QUOTA = 'quota',
  IS_NEW_LOAN = 'isNewLoan',
  PROMOTER = '__promoter',
  MY_CREDITS_LOGOUT = 'myCreditsLogout',
}

export const enum SESSION_STORAGE_ENUMERATION {
  TERM = 'term',
  AMOUNT = 'amount',
  QUOTA = 'quota',
  IS_NEW_LOAN = 'isNewLoan',
}

export enum LOAN_APPLICATION_STATE_ENUMERATION {
  PENDING_SIGNATURE = 'PENDING_SIGNATURE',
  PENDING_DISBURSEMENT = 'PENDING_DISBURSEMENT',
  PENDING_FINISH = 'PENDING_FINISH',
  PENDING_METHOD_DISPERSION = 'PENDING_METHOD_DISPERSION',
}
